import React from 'react';
import { motion } from 'framer-motion';
import { StarIcon } from 'lucide-react';
import { testimonials } from '../data/content';
export function Testimonials() {
  return <section className="bg-white py-16 sm:py-24" aria-labelledby="testimonials-title" data-id="element-181" data-mp="3fznu5mfudd1w">
      <div className="mx-auto max-w-6xl px-5" data-id="element-182" data-mp="3fxb2uio71qc6">
        <div className="text-center" data-id="element-183" data-mp="3b1ch72u92mfg">
          <span className="text-xs font-bold uppercase tracking-[0.2em] text-terracotta" data-id="element-184" data-mp="3b0az4eetgzo8">
            Casos de éxito
          </span>
          <h2 id="testimonials-title" className="mt-4 font-display text-3xl font-black leading-tight text-ink sm:text-4xl" data-id="element-185" data-mp="3205z4pbyd3k3">
            Más de 500 tejedoras ya lo comprobaron
          </h2>
        </div>

        <div className="mt-14 grid gap-6 sm:grid-cols-2 lg:gap-8" data-id="element-186" data-mp="2s308tjb5xgkx">
          {testimonials.map((testimonial, index) => <motion.div key={testimonial.author} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          amount: 0.3
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="flex flex-col justify-between rounded-3xl border border-wool bg-cream p-7 shadow-sm sm:p-9" data-id="element-187" data-mp="v8nar7dvcfh1" data-mpi={index}>
              <div data-id="element-188" data-mp="79v3ezyk0ycg">
                <div className="flex text-terracotta" aria-hidden="true" data-id="element-189" data-mp="c6llfstx640i">
                  {[...Array(5)].map((_, i) => <StarIcon key={i} className="h-5 w-5 fill-current" data-id="element-190" data-mp="zw65yg5q19bw" data-mpi={i} />)}
                </div>
                <blockquote className="mt-6 text-lg leading-relaxed text-ink" data-id="element-191" data-mp="14u7omzz8j6mu">
                  "{testimonial.quote}"
                </blockquote>
              </div>
              <div className="mt-8 border-t border-terracotta/10 pt-5" data-id="element-192" data-mp="v57nb9x9fz5h">
                <p className="font-display text-lg font-bold text-ink" data-id="element-193" data-mp="v3d2dvlzo71e">{testimonial.author}</p>
                <p className="text-sm text-muted" data-id="element-194" data-mp="1ith41xfm9wpr">{testimonial.details}</p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}